import React from 'react'
import GlobalNavTertiary from './GlobalNavTertiary'
import { ScoreCellHeader } from './GameStrip'
import GameHeaderLiveData from './cricket/GameHeaderLiveData'
import PlayerOfTheMatch from './cricket/PlayerOfTheMatch'
import { AnchorLink } from '../common'
import classnames from 'classnames'

export const GameHeader = ({
  gameStrip = {},
  sport = '',
  links = [],
  pageType = '',
  innings = {},
  gameState = '',
  matchFlags = {},
  playerOfTheMatch =[],
  gameStateClassMobile = '',
  summaryText,
  showGameDetailFooter,
  watchESPNLink = {},
  fullWidth = false,
  isWebView = false,
  device = {}
}) => {

  // show player of the match module if total player received the award upto 2
  let showPlayerOfTheMatch = false
  if(playerOfTheMatch.length > 0 && playerOfTheMatch.length < 3) {
    showPlayerOfTheMatch = true
  }

  //minimum one data require to set as true
  let showGameHeaderLiveData = false
  if(innings.crr || innings.rrr || innings.minRemainingOvers || innings.lastNForInnings) {
    showGameHeaderLiveData = true
  }

  return (
    <div className={classnames('sub-module gameHeader', { 'gameHeader--fullWidth': fullWidth })}>
      <div className="gp__cricket__gameHeader">

        <ScoreCellHeader {...gameStrip} 
          sport={sport}
          className={gameStateClassMobile}
          summaryText={summaryText}
          showGameDetailFooter={showGameDetailFooter}
          isUpdatesOnly={matchFlags.updatesOnly}
          gameState={gameState}
          isWebView={isWebView}/>

        {
          //aditional data such as crr,rrr,min ov rem, last n overs data when match is live state
          //do not show if showPlayerOfTheMatch is true ie player of the match is announced
          gameState === 'live' && !showPlayerOfTheMatch && showGameHeaderLiveData &&
          <GameHeaderLiveData  key="ld" crr={innings.crr} rrr={innings.rrr} minRemainingOvers={innings.minRemainingOvers} lastNForInnings={innings.lastNForInnings} isLimitedOvers={matchFlags.limitedOvers} /> 
          || null
        }
        {
          //show player of the match when avaialble
          showPlayerOfTheMatch &&
          <PlayerOfTheMatch key="pm" pom={playerOfTheMatch}/>
          || null
        }

      </div>

      {
        //show Watch ESPN link if available. if available also check if device type is desktop
        gameState === 'live' && watchESPNLink && watchESPNLink.href && device.desktop === true &&
        [        
          <ul className="mobile-button-group">
            <li>
              <AnchorLink to={watchESPNLink.href} classes="button-alt med stand-alone watch-live" isRouterLink={false}>Watch</AnchorLink>
            </li>
          </ul>,
          <ul id="watch-listen-desktop" className="desktop-button-group desktop-tablet-only">
            <li>
              <AnchorLink to={watchESPNLink.href} classes="icon-font-before icon-watch-outline-before" isRouterLink={false}>Watch</AnchorLink>
            </li>
          </ul>
        ]
        || null
      }

      <GlobalNavTertiary links={links} activeKey={pageType} spacerId="watch-listen-desktop" />
    </div>
  ) 
}

export default GameHeader



// WEBPACK FOOTER //
// ../app/components/gamepackage/GameHeader.jsx